// extracted by mini-css-extract-plugin
module.exports = {"link":"_93444fe79c--link--vVdya","image":"_93444fe79c--image--NUPBz","title-wrapper":"_93444fe79c--title-wrapper--g6eLR","title":"_93444fe79c--title--a1MUd"};